__turbopack_context__.v({
  "container": "ULrdpa_container",
  "dashboard": "ULrdpa_dashboard",
  "orderScheduler": "ULrdpa_orderScheduler",
  "overlay": "ULrdpa_overlay",
  "sections": "ULrdpa_sections",
});
